import { set } from "mongoose";
import Head from "next/head";
import React, { useState } from "react";
import ContactUs from "../components/homepage/ContactUs";
import Footer from "../components/homepage/Footer";
import Header from "../components/homepage/Header";
import BigOpportunity from "../components/invest/BigOpportunity";
import DigitalDivide from "../components/invest/DigitalDivide";
import GameChanger from "../components/invest/GameChanger";
import InvestFeatures from "../components/invest/InvestFeatures";
import Manufacturing from "../components/invest/Manufacturing";
import TryItNow from "../components/modal/TryItNow";
import SectionBg from "../public/images/bg-center.png";

const Invest = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div id="invest-page">
      <Header />
      <Head>
        <title>Invest</title>
        <meta name="description" content="" />
      </Head>
      <div
        className="absolute w-full h-[830px] top-0 -z-10 "
        style={{
          backgroundColor: "#fff",
          backgroundImage: `url("${SectionBg.src}")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "830",
        }}
      >
        <div className="relative boxed-container">
          <div className="mt-48 text-center">
            <div className="flex flex-col gap-1 text-6xl font-extrabold">
              <span>Check out our</span>
              <span>amazing story.</span>
            </div>
            <div className="gradient-header">Invest in EasyDuct.</div>
            <div className="w-[80%] mt-8 font-semibold mb-20 m-auto leading-relaxed">
              The best investment any of us can ever make is when we invest in
              things that we know.
              <br /> If after checking out this app, you believe this is a game
              changer for the industry, then please <br />
              consider investing with us in EasyDuct.
            </div>

            <div id="invest-box">
              <div className="box-header">
                <span>Revolutionizing the Way We</span>
                <span>Manage Ductwork - Embracing</span>
                <span>Cutting-Edge Technology for a</span>
                <span>Brighter Future!</span>
              </div>
              <div className="text-[#282D35] text-xl font-extrabold mt-12">
                EasyDuct Simplifies Ductwork Orders for Mechanical Contractors.
              </div>
              <div className="mt-12">
                <button
                  className="sign-up-btn"
                  onClick={() => setIsModalOpen(true)}
                >
                  Sign Up to Invest
                </button>
              </div>
            </div>
          </div>
          <GameChanger />
          <Manufacturing setModalOpen={() => setIsModalOpen(true)} />
          <BigOpportunity />
          <DigitalDivide />
          <InvestFeatures />
          <ContactUs />
          <Footer />
          <TryItNow
            isOpen={isModalOpen}
            onCloseFn={() => setIsModalOpen(false)}
            registrationPurpose="Invest"
          />
        </div>
      </div>
    </div>
  );
};

export default Invest;
Invest.publicPage = true;
